export default "__VITE_ASSET__TOJH3X0j__"